import { getCurrentInstance as ne, ref as c, computed as i, watch as O, nextTick as le, onMounted as oe } from "vue";
import { DEFAULT_DIALOG_TRANSITION as h } from "./index638.js";
import { useLockscreen as te } from "./index639.js";
import { useZIndex as ae } from "./index623.js";
import { useId as B } from "./index640.js";
import { useGlobalConfig as ie } from "./index620.js";
import { defaultNamespace as ue } from "./index559.js";
import { addUnit as re } from "./index641.js";
import { isObject as se, isArray as fe, isFunction as S } from "./index575.js";
import { debugWarn as ce } from "./index588.js";
import { UPDATE_MODEL_EVENT as ve } from "./index584.js";
import { useTimeoutFn as U, isClient as de } from "./index599.js";
const me = "ElDialog", he = (n, a) => {
  var w;
  const u = ne().emit, { nextZIndex: g } = ae();
  let F = "";
  const V = B(), j = B(), r = c(!1), b = c(!1), v = c(!1), C = c((w = n.zIndex) != null ? w : g()), d = c(!1);
  let s, f;
  const N = ie(), G = i(() => {
    var e, l;
    return (l = (e = N.value) == null ? void 0 : e.namespace) != null ? l : ue;
  }), m = i(() => {
    var e;
    return (e = N.value) == null ? void 0 : e.dialog;
  }), Z = i(() => {
    const e = {}, l = `--${G.value}-dialog`;
    if (!n.fullscreen) {
      n.top && (e[`${l}-margin-top`] = n.top);
      const o = re(n.width);
      o && (e[`${l}-width`] = o);
    }
    return e;
  }), q = i(
    () => {
      var e, l, o;
      return ((o = (l = n.draggable) != null ? l : (e = m.value) == null ? void 0 : e.draggable) != null ? o : !1) && !n.fullscreen;
    }
  ), M = i(
    () => {
      var e, l, o;
      return (o = (l = n.alignCenter) != null ? l : (e = m.value) == null ? void 0 : e.alignCenter) != null ? o : !1;
    }
  ), W = i(
    () => {
      var e, l, o;
      return (o = (l = n.overflow) != null ? l : (e = m.value) == null ? void 0 : e.overflow) != null ? o : !1;
    }
  ), J = i(() => M.value ? { display: "flex" } : {}), K = i(() => {
    var e, l, o;
    const L = (o = (l = n.transition) != null ? l : (e = m.value) == null ? void 0 : e.transition) != null ? o : h, p = {
      name: L,
      onAfterEnter: y,
      onBeforeLeave: E,
      onAfterLeave: A
    };
    if (se(L)) {
      const t = { ...L }, T = (_, ee) => (k) => {
        fe(_) ? _.forEach(($) => {
          S($) && $(k);
        }) : S(_) && _(k), ee();
      };
      return t.onAfterEnter = T(t.onAfterEnter, y), t.onBeforeLeave = T(t.onBeforeLeave, E), t.onAfterLeave = T(t.onAfterLeave, A), t.name || (t.name = h, ce(
        me,
        `transition.name is missing when using object syntax, fallback to '${h}'`
      )), t;
    }
    return p;
  });
  function y() {
    u("opened");
  }
  function A() {
    u("closed"), u(ve, !1), n.destroyOnClose && (v.value = !1), d.value = !1;
  }
  function E() {
    d.value = !0, u("close");
  }
  function P() {
    f?.(), s?.(), n.openDelay && n.openDelay > 0 ? { stop: s } = U(() => z(), n.openDelay) : z();
  }
  function D() {
    s?.(), f?.(), n.closeDelay && n.closeDelay > 0 ? { stop: f } = U(() => x(), n.closeDelay) : x();
  }
  function I() {
    function e(l) {
      l || (b.value = !0, r.value = !1);
    }
    n.beforeClose ? n.beforeClose(e) : D();
  }
  function Q() {
    n.closeOnClickModal && I();
  }
  function z() {
    de && (r.value = !0);
  }
  function x() {
    r.value = !1;
  }
  function X() {
    u("openAutoFocus");
  }
  function Y() {
    u("closeAutoFocus");
  }
  function H(e) {
    var l;
    ((l = e.detail) == null ? void 0 : l.focusReason) === "pointer" && e.preventDefault();
  }
  n.lockScroll && te(r);
  function R() {
    n.closeOnPressEscape && I();
  }
  return O(
    () => n.zIndex,
    () => {
      var e;
      C.value = (e = n.zIndex) != null ? e : g();
    }
  ), O(
    () => n.modelValue,
    (e) => {
      var l;
      e ? (b.value = !1, d.value = !1, P(), v.value = !0, C.value = (l = n.zIndex) != null ? l : g(), le(() => {
        u("open"), a.value && (a.value.parentElement.scrollTop = 0, a.value.parentElement.scrollLeft = 0, a.value.scrollTop = 0);
      })) : r.value && D();
    }
  ), O(
    () => n.fullscreen,
    (e) => {
      a.value && (e ? (F = a.value.style.transform, a.value.style.transform = "") : a.value.style.transform = F);
    }
  ), oe(() => {
    n.modelValue && (r.value = !0, v.value = !0, P());
  }), {
    afterEnter: y,
    afterLeave: A,
    beforeLeave: E,
    handleClose: I,
    onModalClick: Q,
    close: D,
    doClose: x,
    onOpenAutoFocus: X,
    onCloseAutoFocus: Y,
    onCloseRequested: R,
    onFocusoutPrevented: H,
    titleId: V,
    bodyId: j,
    closed: b,
    style: Z,
    overlayDialogStyle: J,
    rendered: v,
    visible: r,
    zIndex: C,
    transitionConfig: K,
    _draggable: q,
    _alignCenter: M,
    _overflow: W,
    closing: d
  };
};
export {
  he as useDialog
};
